<app-sprintpay-header
    [showFacilityInformation]="showFacilityInformation"
    [homeURL]="homeURL"
    [cartDisallowedRoutes]="cartDisallowedRoutes"
>
    <ng-content></ng-content>
</app-sprintpay-header>
